<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio</th>
                <th :class="StyleTh">Proveedor</th>
                <th :class="StyleTh">Departamento</th>
                <th :class="StyleTh">Fecha Recepción</th>
                <th :class="StyleTh">Autorizado</th>
                <th :class="StyleTh">Estatus</th>
                <th :class="StyleTh">Total</th>
                <th :class="StyleTh+' text-center'">Elaboración</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>
            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.Folio}}</h6></td>
                    <td><h6 :class="StylePr">{{lista.Proveedor}}</h6></td>
                    <td><p :class="StyleTd">{{lista.Departamento}}</p></td>
                    <td><p :class="StyleTd">{{$getCleanDate(lista.FechaRecep,false)}}</p></td>
                    <td><p :class="StyleTd">{{lista.EstatusAutorizado}}</p></td>
                    <td><p :class="StyleTd">{{lista.Estatus == 'ENCOMPRA' ? 'EN COMPRA' : lista.Estatus}}</p></td>
                    <td><p :class="StyleTd">$ {{lista.Total}}</p></td>
                    <td class="text-center">
                        <button type="button" v-b-tooltip.hover.rightbottom :title="TituloElaboracion(lista)" class="btn btn-link text-warning px-3 mb-0 mr-1">
                            <i class="fas fa-user text-warning"></i>
                        </button>
                    </td>
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="lista.Estatus=='RECIBIR' ? false : lista.Estatus=='AUTORIZADA' ? false : lista.Estatus=='RECHAZADA' ? false : lista.Estatus=='ENCOMPRA' ? false : true" :pShowBtnDelete="lista.Estatus=='RECIBIR' ? false : lista.Estatus=='AUTORIZADA' ? false : lista.Estatus=='RECHAZADA' ? false : lista.Estatus=='AUTORIZACION' ? false : lista.Estatus=='ENCOMPRA' ? false : true" :pIsModal="false" :pId="lista.IdRequisicion" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
                            <template slot="btnaccion">
                                <CMoreButtonsL>
                                    <template slot="bodyBtnsL">
                                        <template v-if="segurity.SendRequest">
                                            <li v-show="lista.Estatus=='ELABORACION'" @click="EnviarRequisicion(lista)">
                                                <a class="dropdown-item">
                                                    <i class="fas fa-file-export"></i> Enviar Solicitud
                                                </a>
                                            </li>
                                        </template>
                                        <template v-if="segurity.ReceiveRequest">
                                            <li v-show="lista.Estatus=='RECIBIR'" @click="RecibirSolicitud(lista)">
                                                <a class="dropdown-item">
                                                    <i class="fas fa-file-download"></i> Recibir Solicitud
                                                </a>
                                            </li>
                                        </template>
                                        <template v-if="segurity.RequestAuthorization">
                                            <li v-show="lista.Estatus=='COTIZANDO'" @click="SolicitarAutorizacion(lista)">
                                                <a class="dropdown-item">
                                                    <i class="fas fa-user-check"></i> Solicitar Autorización
                                                </a>
                                            </li>
                                        </template>
                                        <template v-if="segurity.Authorize">
                                            <li v-show="lista.Estatus=='AUTORIZACION'" @click="Autorizar(lista)">
                                                <a class="dropdown-item">
                                                    <i class="fas fa-file-check"></i> Autorizar Requisición
                                                </a>
                                            </li>
                                        </template>
                                        <li v-show="lista.Estatus=='RECHAZADA'" @click="Autorizar(lista)">
                                            <a class="dropdown-item">
                                                <i class="fas fa-eye"></i> Ver Motivo
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" @click="VerPdf(lista)">
                                                <i class="fas fa-file-pdf"></i> Ver PDF
                                            </a>
                                        </li>
                                    </template>
                                </CMoreButtonsL>
                                <!-- <button v-show="lista.Estatus=='ELABORACION'" @click="EnviarRequisicion(lista)" class="btn btn-warning btn-icon" style="margin-right:5px" v-b-tooltip.hover.rightbottom title="Enviar Solicitud" type="button">
                                    <i class="fas fa-file-export"></i>
                                </button> -->
                                <!-- <button v-show="lista.Estatus=='RECIBIR'" @click="RecibirSolicitud(lista)" class="btn btn-warning btn-icon" style="margin-right:5px" v-b-tooltip.hover.rightbottom title="Recibir Solicitud" type="button">
                                    <i class="fas fa-file-download"></i>
                                </button> -->
                                <!-- <button v-show="lista.Estatus=='COTIZANDO'" @click="SolicitarAutorizacion(lista)" class="btn btn-warning btn-icon" style="margin-right:5px" v-b-tooltip.hover.rightbottom title="Solicitar Autorizacion" type="button">
                                    <i class="fas fa-user-check"></i>
                                </button> -->
                                <!-- <button v-show="lista.Estatus=='AUTORIZACION'" @click="Autorizar(lista)" class="btn btn-warning btn-icon" style="margin-right:5px" v-b-tooltip.hover.rightbottom title="Autorizar Requisición" type="button">
                                    <i class="fas fa-file-check"></i>
                                </button> -->
                                <!-- <button class="btn btn-warning btn-icon" v-b-tooltip.hover.rightbottom title="Ver PDF" type="button">
                                    <i class="fas fa-file-pdf"></i>
                                </button> -->
                                <!-- <button v-show="lista.Estatus=='RECHAZADA'" @click="Autorizar(lista)" class="btn btn-warning btn-icon" style="margin-left:5px;" v-b-tooltip.hover.rightbottom title="Ver Motivo" type="button">
                                    <i class="fas fa-eye"></i>
                                </button> -->
                            </template>
                        </CBtnAccion>     
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
            <template slot="Form">
                <Form :poBtnSave="oBtnSave"></Form>
            </template>
        </CModal>
    </div>
</template>

<script>
import Form from '../requisicion/AutorizarForm.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionRequisicion';
// const EmitEjecuta2 = 'seccionAutorizacion';

export default {
    name: 'ListaRequisicion',
    props: ['sFiltros','pOrigen'],
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Requisiciones',
                IsModal: false,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Almacen',
                GoRoute:'RequisicionForm'
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Autorizar Requisición",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ShowFooter:true
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
        async Lista(){
            this.ConfigList.ShowLoader=true;
            await this.$http.get("requisiciones",{
                params:{
                    TxtBusqueda:this.Filtro.Nombre,
                    Pag:this.Filtro.Pagina,
                    Entrada:this.Filtro.Entrada
                }
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows=res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        Eliminar(Id){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('requisiciones/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus'});
        },
        TituloElaboracion(item){
            let cadena="";
            let UsuarioRecibio = item.usuario_recibio==null ? '' : item.usuario_recibio.NombreCompleto;
            let UsuarioAutorizo = item.usuario_autorizo==null ? '' : item.usuario_autorizo.NombreCompleto;
            let FechaRecibido = item.FechaRecibido==null ? '' : this.$getCleanDate(item.FechaRecibido,true);
            let FechaAutorizacion = item.FechaAutorizacion==null ? '' : this.$getCleanDate(item.FechaAutorizacion,true);

            cadena="Elaboró: "+item.usuario_elaboro.NombreCompleto+
            "\n Fecha Elaboración: "+this.$getCleanDate(item.FechaExp,true)
            if (item.usuario_recibio!=null) {
                cadena+="\n Recibió: "+UsuarioRecibio+
            "\n Fecha Recepción: "+FechaRecibido;
            }
            if (item.usuario_autorizo!=null) {
                cadena+="\n Autorizó: "+UsuarioAutorizo+
            "\n Fecha Autorización: "+FechaAutorizacion;
            }
            // "\n Recibió: "+UsuarioRecibio+
            // "\n Fecha Recepción: "+FechaRecibido+
            // "\n Autorizó: "+UsuarioAutorizo+
            // "\n Fecha Autorización: "+FechaAutorizacion;
            return cadena;
        },
        EnviarRequisicion(item){
            this.$swal(Configs.configEnviarRequisicion).then((result) =>
            {
                if(result.value)
                {
                    this.$http.put('requisicionesEnviar/'+item.IdRequisicion,item
                    ).then((res) => {
                        this.$swal(Configs.configEnviarRequisicionConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        RecibirSolicitud(item){
            this.$swal(Configs.configRecibirSolicitud).then((result) =>
            {
                if(result.value)
                {
                    this.$http.put('requisicionesRecibir/'+item.IdRequisicion,item
                    ).then((res) => {
                        this.$swal(Configs.configRecibirSolicitudConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        SolicitarAutorizacion(item){
            this.$swal(Configs.configSolicitarAutorizacion).then((result) =>
            {
                if(result.value)
                {
                    this.$http.put('requisicionesAutorizacion/'+item.IdRequisicion,item
                    ).then((res) => {
                        this.$swal(Configs.configSolicitarAutorizacionConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Autorizar(item){
            if (item.Estatus=='RECHAZADA') {
                this.ConfigModal.ShowFooter=false;
            }
            else{
                this.ConfigModal.ShowFooter=true;
            }
            // this.bus.$emit('Recovery_'+this.ConfigModal.EmitSeccion,item.IdRequisicion);
            this.bus.$emit('NewModal_'+this.ConfigModal.EmitSeccion,item.IdRequisicion);
        },
        VerPdf(item)
        {
            this.ConfigList.ShowLoader = true;

            let newRequest = {
				IdRequisicion: item.IdRequisicion
			}

			this.$http.post('rptpdfRequisicion',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("Requisicion",'Requisicion_'+item.IdRequisicion,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
                
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        }
    },
    created() {
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();
        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>